import { useCallback, useContext, useEffect, useState } from 'react'

import '../../common/navigation/ScrollingArticles'
import './Library.scss'

import { Button, Col, Container, Row } from 'react-bootstrap'
import Loading from 'templates/Loading'
import SearchInput from './components/SearchInput'
import { getWpCategories } from 'components/common/api/Courses'
import { navigateTo } from 'components/common/navigation'
import { KEY_CATEGORY, ROUTE_BOOKMARKS, ROUTE_CATEGORY, ROUTE_LIBRARY, ROUTE_TODAY } from 'components/common/helpers/Paths'
import { useHistory } from 'react-router-dom'
import { getAuthenticatedUser } from 'components/auth'
import { getAllPracticesDetails } from 'components/common/api/Practices'
import PracticeDiscovery from 'components/practices/PracticeDiscovery'
import Membership from 'components/account/Membership'
import SubscriptionContext from 'components/common/contexts/SubscriptionContext'
import { PARENT_CATEGORIES } from 'components/common/api/constants'

export default function Library({ cache, setReturnPath, setHeaderTitle }) {
  const history = useHistory()
  const user = getAuthenticatedUser()
  const { userSubscription } = useContext(SubscriptionContext);

  const [isLoading, setIsLoading] = useState(true)
  const [practices, setPractices] = useState([])
  const [parentCategories, setParentCategories] = useState([])

  const getCourseCategoriesAsync = useCallback(async () => {
    if (parentCategories.length) return

    let categoriesCourses = await cache.tryGetAsyncResult(
      'course-categories',
      getWpCategories,
      this
    )

    categoriesCourses = categoriesCourses.filter(c => PARENT_CATEGORIES.indexOf(c.name.toLowerCase()) > -1)

    // remove duplicated anxiety
    categoriesCourses = categoriesCourses.map(cat => {
      if (cat.name.toLowerCase() === 'anxiety') {
        if (cat.slug === 'anxiety-2') return cat
        return undefined
      }
      return cat
    }).filter(c => c)

    setParentCategories(categoriesCourses)
    setIsLoading(false)
  }, [cache, parentCategories])

  useEffect(() => {
    setHeaderTitle('')
    setReturnPath(ROUTE_TODAY)

    getCourseCategoriesAsync()

    if (!user || practices.length > 0) return

    const filteredPractices = getAllPracticesDetails().filter(
      practice => practice.active
    )
    setPractices(filteredPractices)

  }, [setHeaderTitle, setReturnPath, getCourseCategoriesAsync, user, practices])

  return (
    <Loading isLoaded={isLoading}>
      <Container className='new-library'>
        <header>
          <Row>
            <Col className='title-wrapper' xs={5}>
              <h1>Library</h1>
            </Col>
            <Col xs={7}>
              <div className='text-end'>
                <Button
                  variant='light'
                  onClick={() => navigateTo(ROUTE_BOOKMARKS, history)}
                  className='library-button'
                >
                  <i className='bi bi-bookmark'></i> your bookmarks
                </Button>
              </div>
            </Col>
          </Row>
        </header>

        <div className='mt-5 categories'>
          <Row>
            <Col>
              <h2>Explore topics</h2>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col>
              <SearchInput
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                returnPath={ROUTE_LIBRARY}
              />
            </Col>
          </Row>

          <Row className='mt-2'>
            <Col className='scroll-categories'>
              <div className='scrolling-articles-wrapper'>
                <ul className='scrolling-card-cards grid'>
                  {parentCategories && parentCategories.map((category, index) => (
                    <li
                      key={index}
                      className='card'
                      onClick={() => {
                        const url = ROUTE_CATEGORY.replace(`:${KEY_CATEGORY}`, category.id)
                        const matchCategory = parentCategories.find(
                          c => c.id === category.id
                        )
                        navigateTo(url, history, { category: matchCategory })
                      }}
                    >
                      {category.name.replace('/', ' / ')}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </div>

        <Membership
          variant='small'
          defaultShow={userSubscription?.active}
          subscription={userSubscription}
          returnPath={ROUTE_LIBRARY}
        />

        {practices.length > 0 && (
          <div className='practices'>
            <Row className='mt-4'>
              <Col>
                <h2>Explore all activities</h2>
              </Col>
            </Row>

            <PracticeDiscovery
              setHeaderTitle={() => {}}
              setReturnPath={()=> {}}
              returnPath={ROUTE_LIBRARY}
              libraryPage
            />
          </div>
        )}

      </Container>
    </Loading>
  )
}
